var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth",style:({ height: _vm.$store.state.clientHeight + 'px' })},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/img/logo.png")}}),_c('div',{staticClass:"vessel"},[_c(_vm.component,{tag:"aside"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }